 
import { GetResponse, getResponse } from '@waitroom/common-api';
import { TFunction } from 'i18next';

export const getResponseMessage = <T>({
  response,
  namespace,
  t,
}: {
  response: GetResponse<T>;
  t: TFunction;
  namespace?: string;
}): [boolean, string?] => {
  const resp = getResponse(response);
  if (!resp) return [false];
  if (typeof resp !== 'object') return [false, String(resp)];
  return [
    resp.success,
    resp.code ? t([`${namespace}${resp.code}`, resp.message || '']) : resp.message,
  ];
};
